<style lang="scss" src="./index.scss"></style>
<template>
  <div :class="{ 'wgt-goods-scroll': true, 'padded': true }">
    <!-- moreLink: {{ value.goodsSetting }} -->
    <div v-if="value.title || value.subtitle" class="wgt-hd">
      <span class="title">{{ value.title }}</span>
      <span class="sub-title">{{ value.subtitle }}</span>
    </div>
    <div class="wgt-bd" :class="{ 'spaced': value.spaced }">
      <!-- 挂件自定义部分 -->
      <div class="scroll-goods">
        <div v-for="(item, index) in goodsList" :key="`scroll-item__${index}`" class="scroll-item">
          <div class="goods-leaderboard">
            <div class="goods-leaderboard-text">NO.{{ index + 1 }}</div>
            <SpImage :src="subscriptImg" :width="40" :height="40" />
          </div>
          <div class="goods-imgs">
            <SpImage :src="item?.pics" :width="130" :height="130" />
          </div>
          <div class="goods-title">{{ item.title }}</div>
          <div class="goods-caption">
            <template>
              <SpPrice :size="15" :value="item.price / 100" />
            </template>
          </div>
        </div>
        <div class="scroll-item">
          <div v-if="value.backgroundImg" class="goods-more">
            <SpImage :src="value.backgroundImg" :width="130" :height="200" />
          </div>
          <div
            v-if="
              !value.backgroundImg &&
              value.moreLink &&
              (value.moreLink.linkUrl || value.moreLink.linkPage)
            "
            class="goods-more"
          >
            查看更多
          </div>
        </div>
      </div>
      <!-- 挂件自定义部分 -->
    </div>
  </div>
</template>

<script>
import config from './config'
const subscript = require('@/assets/img/subscript.png')

export default {
  name: 'WgtJnGroupBuying',
  wgtName: '团购列表',
  wgtDesc: '',
  wgtIcon: 'wgt-jn-group-buying',
  config: config,
  props: {
    value: [Object, Array]
  },
  data() {
    return {
      subscriptImg: subscript,
      goodsList: []
    }
  },
  mounted() {
    this.$api.promotions.getGroupsList({ view: 2, page: 1, pageSize: 20 }).then((response) => {
      this.goodsList = response.list
    })
  },
  methods: {
    getStatusText(status) {
      if (status == 'in_sale') {
        return '后结束'
      } else if (status == 'in_the_notice') {
        return '后开始'
      } else {
        return '活动已结束'
      }
    }
  }
}
</script>
